import React from 'react';

interface IProps {
  fillColor?: string;
}

export const ArrowBack:React.FC<IProps> = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="23" fill="none" viewBox="0 0 22 23">
        <path fill="#204078" d="M14.7 6.699l-4.6 4.6 4.6 4.6-1.4 1.4-6-6 6-6 1.4 1.4z"/>
    </svg>
  )
}